import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'
import store from './store/store'

const config = require('./config.js')

export default {
  padZero (num) {
    var result
    if (num < 10) {
      result = '0' + num
    } else {
      result = '' + num
    }
    return result
  },
  getNow () {
    var now = new Date()
    var res = '' + now.getFullYear() + '/' + this.padZero(now.getMonth() + 1) +
    '/' + this.padZero(now.getDate()) + ' ' + this.padZero(now.getHours()) + ':' +
    this.padZero(now.getMinutes()) + ':' + this.padZero(now.getSeconds())
    return res
  },
  convertStartTime (parsedString) {
    var now = new Date()
    var res = '' + now.getFullYear() + '/' + this.padZero(now.getMonth() + 1) +
    '/' + this.padZero(now.getDate()) + ' ' + parsedString[0] + ':' +
    parsedString[1] + ':' + this.padZero(now.getSeconds())
    return res
  },
  convertTime (now) {
    var res = '' + now.getFullYear() + '/' + this.padZero(now.getMonth() + 1) +
    '/' + this.padZero(now.getDate()) + ' ' + this.padZero(now.getHours()) + ':' +
    this.padZero(now.getMinutes()) + ':' + this.padZero(now.getSeconds())
    return res
  },
  getStartTime () {
    const time = new RegExp('([0-9]{2})', 'g')
    let parsedString = store.state.search.departureTime.match(time)
    var now = new Date()
    var res = '' + now.getFullYear() + '/' + this.padZero(now.getMonth() + 1) +
    '/' + this.padZero(now.getDate()) + ' ' + parsedString[0] + ':' +
    parsedString[1] + ':' + this.padZero(now.getSeconds())
    return res
  },
  calcTime (value) {
    var now = new Date()
    const time = new RegExp('([0-9]{2})', 'g')
    let parsedString = store.state.search.departureTime.match(time)
    this.convertStartTime(parsedString)
    var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parsedString[0], parsedString[1], now.getMinutes())
    dt.setSeconds(dt.getSeconds() + value)
    return {
      start: this.convertStartTime(parsedString),
      end: this.convertTime(dt)
    }
  },
  mappingSpotTypeText () {
    if (store.state.selectedSpotType === '飲食店') return 'restaurant'
    else if (store.state.selectedSpotType === '買い物') return 'shop'
    else if (store.state.selectedSpotType === '観光') return 'sight'
    else if (store.state.selectedSpotType === '温泉') return 'leisure'
  },
  putLog (payload) {
    var now = this.getNow()
    var RelatedJsonData = payload.RelatedJsonData
    if (!RelatedJsonData) RelatedJsonData = null
    var ActionParams = payload.ActionParams
    if (!ActionParams) ActionParams = {}
    let addActionParam = {}
    if (payload.ActionType === 'SearchRoute' ||
    payload.ActionType === 'SearchRouteResults') {
      addActionParam = {
        start: store.state.search.departure,
        start_lon: store.state.DepLatLng.lng(),
        start_lat: store.state.DepLatLng.lat(),
        start_time: this.getStartTime(),
        goal: store.state.search.destination,
        goal_lat: store.state.DesLatLng.lng(),
        goal_lon: store.state.DesLatLng.lat(),
        ...payload.CurrentLatLon
      }
      if (payload.ActionType === 'SearchRouteResults') {
        let time = this.calcTime(payload.duration_value)
        addActionParam = {
          ...addActionParam,
          start_time: time.start,
          goal_time: time.end
        }
      }
    } else if (payload.ActionType === 'SearchSpots') {
      addActionParam = {
        category: this.mappingSpotTypeText(),
        start_lon: store.state.DepLatLng.lng(),
        start_lat: store.state.DepLatLng.lat(),
        ...payload.CurrentLatLon
      }
      RelatedJsonData = JSON.stringify(RelatedJsonData)
    } else if (payload.ActionType === 'TapSpot' ||
    payload.ActionType === 'ChooseSpot' ||
    payload.ActionType === 'SeeDetail' ||
    payload.ActionType === 'ChooseSpotInDetail' ||
    payload.ActionType === 'PushReliefButton') {
      let rating = store.state.selectedSpot.rating
      if (!rating) rating = store.state.selectedSpot.reputation
      let congestion
      if (store.state.selectedSpot.reports && store.state.selectedSpot.reports[0]) congestion = store.state.selectedSpot.reports[0].congestion
      let lat
      let lng
      if (store.state.selectedSpot.geometry) {
        lat = store.state.selectedSpot.geometry.location.lat()
        lng = store.state.selectedSpot.geometry.location.lng()
      } else {
        lat = store.state.selectedSpot.lat
        lng = store.state.selectedSpot.lon
      }
      let openingHours = store.state.selectedSpot.business_hours
      if (!openingHours) {
        if (store.state.selectedSpot.opening_hours) {
          openingHours = store.state.selectedSpot.opening_hours.weekday_text
        }
      }
      addActionParam = {
        name: store.state.selectedSpot.name,
        lat: lat,
        lon: lng,
        opening_hours: openingHours,
        rating: rating,
        category: this.mappingSpotTypeText(),
        congestion: congestion
      }
      if (payload.ActionType === 'PushReliefButton') {
        addActionParam = {
          ...addActionParam,
          ...payload.CurrentLatLon,
          ServicePlacdeId: this.getGmapId(),
          SpotId: this.getOriApiId()
        }
      }
    } else if (payload.ActionType === 'RunMapApp') {
      addActionParam = {
        start: store.state.search.departure,
        start_lon: store.state.DepLatLng.lng(),
        start_lat: store.state.DepLatLng.lat(),
        start_time: this.getStartTime(),
        goal: store.state.dropDestionaton.name,
        goal_lat: store.state.dropDestionaton.latlng.lng(),
        goal_lon: store.state.dropDestionaton.latlng.lat(),
        end_time: this.calcTime(store.state.lastRoute.routes[0].legs[0].duration_in_traffic.value).end
      }
    } else if (payload.ActionType === 'DepartDirectly') {
      addActionParam = {
        start: store.state.search.departure,
        start_lon: store.state.DepLatLng.lng(),
        start_lat: store.state.DepLatLng.lat(),
        goal: store.state.dropDestionaton.name,
        goal_lat: store.state.dropDestionaton.latlng.lng(),
        goal_lon: store.state.dropDestionaton.latlng.lat()
      }
    } else if (payload.ActionType === 'SeeLastQ' ||
    payload.ActionType === 'AnswerLastQ') {
      addActionParam = {
        ...payload.CurrentLatLon
      }
    } else if (payload.ActionType === 'Debug') {
      addActionParam = {
        status: payload.status,
        start_lon: payload.origin,
        goal: payload.destination
      }
    }

    firebase.firestore().collection('logs').add({
      ActionType: payload.ActionType,
      ActionParams: JSON.stringify({...payload.CurrentLatLon, ...addActionParam, ...ActionParams}),
      RelatedJsonData: RelatedJsonData,
      RegistrationAutoId: store.state.uid,
      CreatedAt: now,
      UpdatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    }).then(ref => {
      // success
    })
  },
  init () {
    firebase.initializeApp(config.firebaseConfig)
  },
  putRegistraton () {
    var now = this.getNow()
    firebase.firestore().collection('registrations').add({
      Agreement: -1,
      Platform: 'Web',
      CreatedAt: now,
      UpdatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    }).then(ref => {
      store.commit('changeUid', ref.id)
    })
  },
  putLocation () {
    var now = this.getNow()
    firebase.firestore().collection('locations').add({
      RegistrationAutoId: store.state.uid,
      Lat: store.state.currentLat,
      Lon: store.state.currentLng,
      CreatedAt: now,
      UpdatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    }).then(ref => {
      // success
    })
  },
  getRegistraion () {
    firebase.firestore().collection('registrations').doc(store.state.uid).get()
      .then(doc => {
        if (!doc.exists) {
          // no such document
        } else {
          store.commit('changeRegData', doc.data())
          if (doc.data().Agreement === 10) {
            store.commit('changeIsAgreed')
          } else {
            store.commit('changeIsNotAgreed')
          }
          if (doc.data().ExperimentParticipant === 10) {
            store.commit('changeIsExperimentParticipant')
          }
          if (doc.data().FinalQAnswerd === 10) {
            store.commit('changeFinalQAnswerd')
          }
        }
      })
      .catch(err => {
        alert('登録情報取得中にエラーが発生しました。管理者にご連絡ください。', err)
      })
  },
  agreeConsent () {
    firebase.firestore().collection('registrations').doc(store.state.uid).update({
      Agreement: 10,
      UpdatedAt: this.getNow()
    }).then(ref => {
      store.commit('changeIsAgreed')
    })
  },
  finalQShown () {
    firebase.firestore().collection('registrations').doc(store.state.uid).update({
      FinalQShown: 10,
      UpdatedAt: this.getNow()
    }).then(ref => {
      // success
    })
  },
  finalQAnswerd () {
    firebase.firestore().collection('registrations').doc(store.state.uid).update({
      FinalQAnswerd: 10,
      UpdatedAt: this.getNow()
    }).then(ref => {
      store.commit('changeFinalQAnswerd')
    })
  },
  agreeExperimentParticipant () {
    firebase.firestore().collection('registrations').doc(store.state.uid).update({
      ExperimentParticipant: 10,
      UpdatedAt: this.getNow()
    }).then(ref => {
      store.commit('changeIsExperimentParticipant')
    })
  },
  getAnswersExist () {
    firebase.firestore().collection('registrations').doc(store.state.uid).collection('answers').get()
      .then((snapshot) => {
        if (!snapshot.empty) {
          store.commit('changeIsAnswered')
        } else {
          store.commit('changeIsNotAnswered')
        }
      })
      .catch(err => {
        alert('登録情報取得中にエラーが発生しました。管理者にご連絡ください。', err)
      })
  },
  getSpot () {
    // 独自APIのIDで検索
    var oriApiId = this.getOriApiId()

    if (oriApiId) {
      firebase.firestore().collection('spots').where('SpotId', '==', oriApiId).get()
        .then(snapshot => {
          if (snapshot.empty) {
            return 0
          }

          snapshot.forEach(doc => {
          // データが存在するなら、セットして終了
            store.commit('setSelectedSpotData', {relieved: doc.data().Relieved, id: doc.id})
            return 0
          })
        })
        .catch(err => {
          alert('場所情報取得中にエラーが発生しました。管理者にご連絡ください。', err)
        })
    }

    // 独自APIのIDで何もみつからなかった場合
    // GoogleMapAPIのPlaceIDで検索
    var GMapApiId = this.getGmapId()
    if (GMapApiId) {
      firebase.firestore().collection('spots').where('ServicePlacdeId', '==', GMapApiId).get()
        .then(snapshot => {
          if (snapshot.empty) {
            return 0
          }

          snapshot.forEach(doc => {
            store.commit('setSelectedSpotData', {relieved: doc.data().Relieved, id: doc.id})
            return 0
          })
        })
        .catch(err => {
          alert('場所情報取得中にエラーが発生しました。管理者にご連絡ください。', err)
        })
    }
  },
  getOriApiId () {
    if (store.state.selectedSpot.place_id) {
      // selectedSpotがplace_idを持っている場合はGoogleMapAPIの情報なので、独自APIのIDに変換する
      let oriApiData = store.state.originalApiData.filter(x => x.service_place_id === store.state.selectedSpot.place_id)
      if (oriApiData.length) {
        return oriApiData[0].id
      }
    } else {
      // place_idをもっていない場合は独自APIの情報なので、そのまま
      return store.state.selectedSpot.id
    }
  },
  getGmapId () {
    if (store.state.selectedSpot.place_id) {
      // selectedSpotがplace_idを持っている場合はGoogleMapAPIの情報なので、そのまま
      return store.state.selectedSpot.place_id
    } else {
      // place_idをもっていない場合は独自APIの情報なので、GoogleMapAPIのIDを取得する
      return store.state.selectedSpot.service_place_id
    }
  },
  mappingUndefinedToNull (value) {
    if (value === undefined) {
      return null
    }
    return value
  },
  putSpot () {
    if (store.state.relievedLog.filter(x => x === store.state.selectedSpotDocId).length) {
      return 0
    }
    var now = this.getNow()
    if (!store.state.selectedSpotDocId) {
      // ない場合は新規作成
      firebase.firestore().collection('spots').add({
        ServicePlacdeId: this.mappingUndefinedToNull(this.getGmapId()),
        SpotId: this.mappingUndefinedToNull(this.getOriApiId()),
        Relieved: 1,
        CreatedAt: now,
        UpdatedAt: now,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      }).then(ref => {
        store.commit('updateRelievedData', {relieved: 1, id: ref.id})
      })
    } else {
      // ある場合はアップデート
      let next = store.state.selectedSpotRelieved + 1
      firebase.firestore().collection('spots').doc(store.state.selectedSpotDocId).update({
        Relieved: next,
        UpdatedAt: now,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      }).then(ref => {
        store.commit('updateRelievedData', {relieved: next, id: store.state.selectedSpotDocId})
      })
    }
  },
  createAnsDoc (question, content, now) {
    return {
      RegistrationAutoId: store.state.uid,
      Question: question,
      Content: content,
      CreatedAt: now,
      UpdatedAt: now
    }
  },
  putAnswers (ans) {
    var now = this.getNow()
    let batch = firebase.firestore().batch()
    let ref = firebase.firestore().collection('registrations').doc(store.state.uid).collection('answers')
    batch.set(ref.doc('sex'), this.createAnsDoc('性別', ans.settings.sex, now))
    batch.set(ref.doc('age'), this.createAnsDoc('年齢', ans.settings.age, now))
    batch.set(ref.doc('purpose'), this.createAnsDoc('旅行目的', ans.settings.purpose, now))
    batch.set(ref.doc('fellow'), this.createAnsDoc('同行者', ans.settings.fellow, now))
    batch.set(ref.doc('elder_fellow'), this.createAnsDoc('65歳以上の同行者', ans.settings.elder_fellow, now))
    batch.set(ref.doc('comment'), this.createAnsDoc('コメント', ans.settings.comment, now))
    batch.set(ref.doc('consider'), this.createAnsDoc('ひごろ渋滞考慮', ans.consider, now))
    batch.set(ref.doc('late'), this.createAnsDoc('出発時間を遅らせられる', ans.late, now))
    batch.commit().then(function () {
      store.commit('changeIsAnswered')
    })
  },
  putLastAnswers (answers) {
    var now = this.getNow()
    let batch = firebase.firestore().batch()
    let ref = firebase.firestore().collection('registrations').doc(store.state.uid).collection('answers')

    for (let ans of answers) {
      for (let key of Object.keys(ans.data)) {
        let ques = ans.item.filter(x => x.name === key)[0].label
        let dockey = key
        if (ans.type !== undefined) {
          ques = ans.type + ques
          dockey = ans.type + dockey
        }
        batch.set(ref.doc(dockey), this.createAnsDoc(ques, ans.data[key], now))
      }
    }
    batch.commit().then(function () {
      // success
    })
  }
}



// WEBPACK FOOTER //
// ./src/firebase.js